// src/components/Auth/LogoutComponent.tsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'aws-amplify/auth';
import { useUserContext } from '../Context/UserContext';

export default function LogoutComponent() {
  const navigate = useNavigate();
  const { setFirstName, setEmail } = useUserContext();

  useEffect(() => {
    (async () => {
      try {
        // Sign out from Cognito (ignore errors if already signed out)
        try {
          await signOut({ global: true });
        } catch (e) {
          console.log('[Logout] signOut failed or user already signed out:', e);
        }

        // Clear user context
        setFirstName(null);
        setEmail(null);

        // Clear browser storage
        try {
          localStorage.clear();
        } catch (e) {
          console.warn('[Logout] localStorage.clear failed:', e);
        }

        try {
          sessionStorage.clear();
        } catch (e) {
          console.warn('[Logout] sessionStorage.clear failed:', e);
        }
      } finally {
        // Send user back to home page
        navigate('/', { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
